import { useEffect, useState, useCallback } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import api from "../../api/api";
import { useParams } from "react-router-dom";
import { plusIcon, refreshIcon, refreshinrefils } from "../../landingscreen/modals/svgs";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { PharmacyModal } from "./modals/pharmacymodal";
import { PrescriptionModal } from "./modals/PrescriptionModal";
import { useSelector } from "react-redux";
import { OrderIcons } from "../OrderCards";
import { getPracticeId } from "../../config/practice";
import { forgetDefaultPharmacy, getDefaultPharmacy, pharmacyDepartmentId } from "../../api/defaultPharmacy";
import { canDecide, durationText, isPatientStop, isPendingRefill, quantityText, refillUpdateFields, rowStatus, rowTitle } from "./refillRows";

// The patient's name from the chart row ("First Last"), as the other Orders
// tabs send it; "" when the row has none (the server fills it from the chart).
export const refillPatientName = (data) =>
  `${data?.firstname || ""} ${data?.lastname || ""}`.trim() ||
  String(data?.patient_name || data?.patientname || "").trim();

const Refillstab = ({ data, appointmentId, startDate, setShowOrders }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [Backdroploading,setBackdropLoading]=useState(false)
  useParams(); // Keep for potential future use
  const [respdata, setrespdata] = useState([]);
  console.log("respdata",respdata);
  
  const [visibleInputIndex, setVisibleInputIndex] = useState(null);
  const [filtercounts,setFilterCounts]=useState({"total_medications": 0,
        "active_medications": 0,
        "inactive_medications": 0})
  const [isPharmacySelected, setIspharmacySelected] = useState(false);
  const [pharmacyText, setPharmacyText] = useState("");
  const [pharmacySuggestions, setPharmacySuggestions] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("all");
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  // Result of the last Approve all / Reject all: { text, tone } (partial failures are listed).
  const [bulkResult, setBulkResult] = useState(null);
  const practiseid = getPracticeId();
  const params = useParams();
  const dt = params.dt || startDate ;
 const userConfig = useSelector((state) => state.userconfig);
 const[selectedpharma,setSelectedPharma]=useState('')
 const [isaddpharma,setIsAddPharma]=useState(false)
 const[pharmadetails,setPharmaDetails]=useState({})
 const tabs=[
              { key: "requested", label: "Requested",prop:"req", count: filtercounts.requested_medications },
            { key: "all", label: "All",prop:"", count: filtercounts.total_medications },
 { key: "active", label: "Active",prop:"A", count: filtercounts.active_medications },
 { key: "inactive", label: "In Active", prop:"I",count: filtercounts.inactive_medications },
//  { key: "pending", label: "Pending", prop:"",count: pendingCount }
            ]
 const normalizeResponse = (data) => {
  if (!data) return [];

  const statusMap = {};
  (data.medicationstatus || []).forEach((s) => {
    statusMap[s.medicationentryid] = s;
  });

  return (data.medicationdata || []).map((med) => ({
    ...med,
    ...statusMap[med.medicationentryid], // merge status info by ID
  }));
};

  // force: only the Refresh button (an explicit user refresh). v1 sync-medication skips the
  // Athena read when the patient was synced recently (V1_MED_SYNC_GATE_SECONDS, now 900 s);
  // ?force=1 always reads Athena. Open and the filter tabs stay gated.
  const fetchData = async({status=false,filter=undefined,force=false}) => {
    try {
      if(!status){
          setIsLoading(true)
              await api.post(`v1/${practiseid}/medications/patient/${data.patientid}/sync-medication${force?"?force=1":""}`)
      }else{
        setBackdropLoading(true)
      }
   const countsresponse= await api.get(`/v1/${practiseid}/medications/patient/${data.patientid}/count`)
   if(countsresponse.status==200){
    setFilterCounts(countsresponse.data)
   }else{
    setFilterCounts({"total_medications": 0,
        "active_medications": 0,
        "inactive_medications": 0})
   }
  const params = {};

if (filter !== undefined && filter !== null && filter !== "") {
  params.status = filter;
}

const response = await api.get(
  `/v1/${practiseid}/medications/patient/${data.patientid}/refills`,
  { params }
)
      if (response.status === 200) {
    const merged = normalizeResponse(response.data);
      setrespdata(merged);
      console.log(merged,'d')
      } else {
        setrespdata([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBackdropLoading(false)
      setIsLoading(false);
    }
  }

// Default pharmacy: a billed Athena read (../../api/defaultPharmacy.js), asked under the
// patient's department (was the user's). The panel only SHOWS it, so on open it reads with
// cache (a kept answer, or v2's cache via ?cache=1). It is read fresh (no cache) only when
// it is USED: Add medication, which writes it into the prescription, and after our own
// change. Reads at the same moment share one request. An unchanged answer keeps the same
// object, so an open Add medication dialog does not reset its pharmacy field.
const pharmacyDepartment=pharmacyDepartmentId(data,userConfig?.config?.departmentid)
const samePharmacy=(a,b)=>JSON.stringify(a||{})===JSON.stringify(b||{})
const fetchpharmacydata=async({cache=false}={})=>{
try {
  const response=await getDefaultPharmacy({practiceId:practiseid,patientId:data.patientid,departmentId:pharmacyDepartment,cache})
  const next=response.status==200?(response.data||{}):{}
  setPharmaDetails((prev)=>(samePharmacy(prev,next)?prev:next))
} catch (error) {
  console.log(error)
}
}
useEffect(()=>{
  if(data.patientid&&practiseid){
  fetchData({status:false})
  fetchpharmacydata({cache:true})
  }
console.log('dtaaa',data)
},[data.patientid])

  const fetchPharmacySuggestions = async () => {
    if (pharmacyText.trim().length > 1) {
      // Trigger API only after 3 characters
      try {
        const response = await api.post(
          `/v1/${practiseid}/rx/patient/${data.patientid}/department/${data.departmentid}/pharmalook`,
          {
            facility_name: pharmacyText,
          }
        );
        if (response.status === 200) {
          setPharmacySuggestions(response.data.slice(0, 5) || []);
        }else{
           setPharmacySuggestions([])
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    }
  }

  const toggleInputVisibility = (index) => {
    setVisibleInputIndex(visibleInputIndex === index ? null : index); // Toggles visibility for the clicked card
  };
  const updatePharmacy = async (obj) => {

    setIsLoading(true)
    try {
      await api.post(`/v1/${practiseid}/patients/${data?.patientid}/pharmacies/default`, {
  "departmentid":pharmacyDepartment,
  "clinicalproviderid":selectedpharma?.facilityid
      });
    } catch (error) {
      console.log(error);
    } finally {
    forgetDefaultPharmacy(practiseid, data?.patientid)
    fetchpharmacydata()
      setPharmacyText("");
      setSelectedPharma('')
    setIsLoading(false)
    }
  };
  const updateDuration = async (obj) => {
    try {
      await api.put(`/v1/${practiseid}/patient/refills/duration`, obj);
    } catch (error) {
      console.log(error);
    } finally {

    }
  };
  // One Approve / Reject. Returns true when the server saved it; the caller refreshes the list
  // (Approve all / Reject all refresh once at the end).
  const sendDecision = async (row, decision) => {
    const formData = new FormData();
    Object.entries(refillUpdateFields(row, decision)).forEach(([key, value]) => formData.append(key, value));
    formData.append("orderdate", dt || "");
    // The refill task's patient_name is the PATIENT (owner 10-19: it held the
    // staff login); the staff login goes in created_by (who approved it).
    formData.append("pat_name", refillPatientName(data));
    formData.append("created_by", userConfig?.username || "");
    try {
      const response = await api.post(
        `/v1/${practiseid}/medications/patient/${data.patientid}/update`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return Number(response?.status) === 200 || response?.result === true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const refreshAfterChange = () => {
    const selectedfilter = tabs.find((t) => t.key === activeTabKey);
    return fetchData({ status: true, filter: selectedfilter?.prop });
  };

  const markstatus = async (row, decision) => {
    setBackdropLoading(true);
    setBulkResult(null);
    const ok = await sendDecision(row, decision);
    if (!ok) setBulkResult({ tone: "error", text: `Could not ${decision} ${row?.medication || "the medication"}. Please try again.` });
    setBackdropLoading(false);
    refreshAfterChange();
  };

  // Approve all / Reject all: every pending refill row on screen, one at a time; failures are
  // listed by name and the rest still go through.
  const visiblePending = (respdata || []).filter(isPendingRefill);
  const decideAll = async (decision) => {
    const rows = visiblePending;
    if (!rows.length) return;
    const verb = decision === "approve" ? "Approve" : "Reject";
    if (typeof window !== "undefined" && window.confirm
      && !window.confirm(`${verb} ${rows.length} pending refill(s)?`)) return;
    setBackdropLoading(true);
    setBulkResult(null);
    const failed = [];
    let done = 0;
    for (const row of rows) {
      // eslint-disable-next-line no-await-in-loop
      if (await sendDecision(row, decision)) done += 1;
      else failed.push(row.medication || row.medicationentryid);
    }
    setBackdropLoading(false);
    const past = decision === "approve" ? "approved" : "rejected";
    setBulkResult(failed.length
      ? { tone: "error", text: `${done} of ${rows.length} ${past}. Failed: ${failed.join(", ")}` }
      : { tone: "ok", text: `${done} refill(s) ${past}.` });
    refreshAfterChange();
  };

  const RowCheck = ({ on }) => (
    <span className={`bmor-rf-check${on ? " on" : ""}`} aria-hidden="true">
      {on && (
        <svg width="10" height="9" viewBox="0 0 8 7" fill="none">
          <path d="M7.10223 1.21094L2.50848 5.80469L0.42041 3.71662" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </span>
  );
  const stats = [
    { label: "Pending refills", value: filtercounts?.pending_refills || 0, tone: "blue" },
    { label: "Approved today", value: filtercounts?.approved_today || 0, tone: "green" },
    { label: "Cancelled today", value: filtercounts?.cancelled_today || 0, tone: "red" },
    {
      label: "Total requests",
      value:
        (filtercounts?.pending_refills || 0) +
        (filtercounts?.approved_today || 0) +
        (filtercounts?.cancelled_today || 0),
      tone: "grey",
    },
  ];

  return (
    <>
      <div className="bmor bmor-rf">
        {/* Summary */}
        <div className="bmor-rf-stats">
          {stats.map((s) => (
            <div key={s.label} className="bmor-rf-stat">
              <div className={`bmor-rf-stat-v ${s.tone}`}>{s.value}</div>
              <div className="bmor-rf-stat-l">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Default pharmacy */}
        <div className="bmor-rf-pharmacy">
          <div style={{ minWidth: 0 }}>
            <div className="bmor-section-title">Default pharmacy</div>
            <div className="bmor-rf-ph-name">{pharmadetails?.clinicalprovidername || "-"}</div>
            <div className="bmor-rf-ph-addr">{pharmadetails?.address1 || "-"}</div>
          </div>
          <button type="button" className="bmor-btn" onClick={() => { setIsAddPharma(true); }}>
            Change pharmacy
          </button>
        </div>

        {/* Filters + add */}
        <div className="bmor-rf-toolbar">
          <div className="bmor-chips">
            {tabs.map((t) => {
              const selected = activeTabKey === t.key;
              return (
                <button
                  key={t.key}
                  type="button"
                  className={`bmor-rf-filter${selected ? " on" : ""}`}
                  aria-pressed={selected}
                  onClick={() => {
                    setActiveTabKey(t.key);
                    if (t.prop) {
                      fetchData({ status: false, filter: t.prop });
                    } else {
                      fetchData({ status: false });
                    }
                  }}
                >
                  {t.label}
                  <span className="bmor-tab-n">{t.count}</span>
                </button>
              );
            })}
            <button
              type="button"
              className="bmor-rf-filter ghost"
              onClick={() => {
                setActiveTabKey("all");
                fetchData({ status: false, filter: "", force: true });
              }}
            >
              {refreshinrefils}
              Refresh
            </button>
          </div>
          <button type="button" className="bmor-btn primary" onClick={() => { fetchpharmacydata(); setShowPrescriptionModal(true); }}>
            {OrderIcons.plus}
            Add medication
          </button>
        </div>

        <div className="bmor-rf-table">
          {isLoading ? (
            <div className="bmor-card-empty">Loading…</div>
          ) : respdata?.length ? (
            <>
              <div className="bmor-rf-scroll">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: 52 }}>
                        <RowCheck on={respdata.some((res) => res.refill === "Y") && respdata.filter((res) => res.refill === "Y").every((res) => res.refillApprove === "Y")} />
                      </th>
                      <th>Medication</th>
                      <th>Quantity</th>
                      <th>Duration</th>
                      <th>Status</th>
                      <th style={{ textAlign: "right" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {respdata.map((res, index) => {
                      const qty = quantityText(res);
                      const days = durationText(res);
                      const approved = res.refillApprove === "Y" && res.refill === "Y";
                      const st = rowStatus(res);
                      const stopped = isPatientStop(res);
                      return (
                        <tr key={res.medicationentryid || index}>
                          <td>
                            <RowCheck on={approved} />
                          </td>
                          <td>
                            <div className="bmor-item-name" style={{ fontSize: 15 }}>{rowTitle(res)}</div>
                            {st.sub ? <div className="bmor-item-sub">{st.sub}</div> : null}
                          </td>
                          <td>{qty ? <span className="bmor-rf-qty">{qty}</span> : "-"}</td>
                          <td>{days || "-"}</td>
                          <td>
                            {st.tone === "ok" ? (
                              <span className="bmor-pill ok" style={{ marginTop: 0 }}>{st.label}</span>
                            ) : st.tone === "pending" ? (
                              <span className="bmor-pill" style={{ marginTop: 0, background: "#fef6dc", color: "#8a5a00" }}>{st.label}</span>
                            ) : st.tone === "inactive" ? (
                              <span className="bmor-pill" style={{ marginTop: 0, background: "#f1f2f4", color: "#4a5565" }}>{st.label}</span>
                            ) : st.tone === "new" ? (
                              <span className="bmor-pill" style={{ marginTop: 0, background: "#f3e8ff", color: "#6b21a8" }}>{st.label}</span>
                            ) : (
                              <span className="bmor-pill" style={{ marginTop: 0, background: "#e8f0fe", color: "#1d4ed8" }}>{st.label}</span>
                            )}
                          </td>
                          <td>
                            {!canDecide(res) ? (
                              <div className="bmor-rf-actions" style={{ color: "#4a5565", fontSize: 13 }}>Handled in Tasks</div>
                            ) : (
                            <div className="bmor-rf-actions">
                              <button
                                type="button"
                                className="bmor-rf-approve"
                                disabled={approved}
                                onClick={() => markstatus(res, "approve")}
                              >
                                <CheckIcon fontSize="small" />
                                Approve
                              </button>
                              <button
                                type="button"
                                className="bmor-rf-reject"
                                disabled={stopped}
                                title={stopped ? "The patient stopped this medication" : undefined}
                                onClick={() => markstatus(res, "reject")}
                              >
                                <CloseIcon fontSize="small" />
                                Reject
                              </button>
                            </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="bmor-card-foot">
                <span>{filtercounts?.pending_refills || 0} pending refill(s) require attention</span>
                <span style={{ display: "flex", gap: 10 }}>
                  <button
                    type="button"
                    className="bmor-rf-approve"
                    disabled={!visiblePending.length}
                    onClick={() => decideAll("approve")}
                  >
                    Approve all pending
                  </button>
                  <button
                    type="button"
                    className="bmor-rf-reject outline"
                    disabled={!visiblePending.length}
                    onClick={() => decideAll("reject")}
                  >
                    Cancel all pending
                  </button>
                </span>
              </div>
            </>
          ) : (
            <div className="bmor-card-empty">No data available</div>
          )}
          {bulkResult && (
            <div
              role="status"
              className="bmor-card-foot"
              style={{ color: bulkResult.tone === "error" ? "#b42318" : "#067647" }}
            >
              {bulkResult.text}
            </div>
          )}
        </div>
      </div>

      {/* Outside the table: both open whether or not the patient has medications. */}
      {isaddpharma && (
        <PharmacyModal
          pharmacyText={pharmacyText}
          setPharmacyText={setPharmacyText}
          pharmacySuggestions={pharmacySuggestions}
          setPharmacySuggestions={setPharmacySuggestions}
          isPharmacySelected={isPharmacySelected}
          setIspharmacySelected={setIspharmacySelected}
          updatePharmacy={updatePharmacy}
          visibleInputIndex={visibleInputIndex}
          respdata={respdata}
          onClose={() => setIsAddPharma(false)}
          setSelectedPharma={setSelectedPharma}
          fetchPharmacySuggestions={fetchPharmacySuggestions}
        />
      )}

      {showPrescriptionModal && (
        <PrescriptionModal
          selectedpharma={pharmadetails}
          userdata={data}
          isOpen={showPrescriptionModal}
          onClose={() => setShowPrescriptionModal(false)}
        />
      )}
      <Backdrop
        sx={{
          color: "secondary.main", // Sets the CircularProgress color to secondary
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading || Backdroploading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
    </>
  );
};
export default Refillstab;
